import { __awaiter } from "tslib";
import { CONTENT_TILES_DEFAULT_SIZE, } from '@as-react/common-types';
import { axiosClient } from '@as-react/common-utils';
import { stringify } from 'qs';
class ContentApi {
    constructor() {
        this.getContentFromElasticSearch = (defaultRequestParams_1, servicesApi_1, elasticsearchIndex_1, ...args_1) => __awaiter(this, [defaultRequestParams_1, servicesApi_1, elasticsearchIndex_1, ...args_1], void 0, function* (defaultRequestParams, servicesApi, elasticsearchIndex, page = 0, size = CONTENT_TILES_DEFAULT_SIZE, path, q, tags) {
            const axiosConfig = {
                method: 'GET',
                url: `${servicesApi}api/content/search`,
                params: Object.assign(Object.assign({}, defaultRequestParams), { index: elasticsearchIndex, q,
                    tags,
                    size, from: page * size, path, author: false }),
                withCredentials: true,
                paramsSerializer: params => stringify(params, { arrayFormat: 'repeat' }),
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
        this.getFilters = (servicesApi, mainWebshop, path, category, type) => __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'GET',
                url: `${servicesApi}api/services/public/tag/filters`,
                params: {
                    mainwebshop: mainWebshop,
                    path,
                    category,
                    type,
                },
                withCredentials: true,
                paramsSerializer: params => stringify(params, { arrayFormat: 'repeat' }),
            };
            const result = yield axiosClient.request(axiosConfig);
            return result.data;
        });
    }
}
export default new ContentApi();
